import { createFileRoute } from '@tanstack/react-router'
import { useSetDetail } from '@/pages/organizations/detail/sets/detail'
import ReportPage from '@/pages/organizations/detail/sets/detail/report'

export const Route = createFileRoute(
  '/app/organizations/$organizationId/sets/$setId/report',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { assessment, organization } = useSetDetail()

  return (
    <ReportPage
      assessment={assessment}
      organization={organization}
      program={assessment.program}
    />
  )
}
